import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './features/auth/LoginPage';
import RecoverPage from './features/auth/RecoverPage';
import RegisterPage from './features/auth/RegisterPage';
import AcceptInvitePage from './features/auth/AcceptInvitePage';
import VaultList from './features/vault/VaultList';
import NotesList from './features/notes/NotesList';
import AuthenticatorPage from './features/authenticator/AuthenticatorPage';
import AuditPage from './features/audit/AuditPage';
import BreakGlassPage from './features/break-glass/BreakGlassPage';
import AccountPage from './features/account/AccountPage';
import SecurityDashboardPage from './features/security/SecurityDashboardPage';
import SettingsPage from './features/settings/SettingsPage';
import TrashPage from './features/trash/TrashPage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/recover" element={<RecoverPage />} />
      <Route path="/accept-invite" element={<AcceptInvitePage />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/vault" replace />} />
        <Route path="/vault" element={<VaultList />} />
        <Route path="/break-glass" element={<BreakGlassPage />} />
        <Route path="/authenticator" element={<AuthenticatorPage />} />
        <Route path="/notes" element={<NotesList />} />
        <Route path="/notes/:tenantSlug/*" element={<NotesList />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="/security" element={<SecurityDashboardPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/trash" element={<TrashPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/vault" replace />} />
    </Routes>
  );
}
